import { useState } from "react";
import { templateService } from "../../service";

function CreateSMSTemplate() {
  const [smsTemplateData, setSMSTemplateData] = useState({});

  const setInputValue = (e) => {
    setSMSTemplateData({
      ...smsTemplateData,
      [e.target.id]: e.target.value,
    });
  };

  const verifySMS = () => {
    const response = templateService.verifySMS(smsTemplateData);
  };

  return (
    <div>
      <div className="flex-nowrap flex-center justify-content-between">
        <div>
          <h5>Create SMS Template</h5>
        </div>
      </div>
      <div className="card border rounded-border-sm  mt-4">
        <div className="p-2 border-bottom">
          <p className="f-500">SMS Details</p>
        </div>
        <div className="p-2 flex-wrap justify-content-between">
          <div className="fc-5">
            <div className="input-wrapper">
              <p className="input-title">Template Name</p>
              <label className="input">
                <input
                  type="text"
                  placeholder="Template Name"
                  id="template_name"
                  value={smsTemplateData?.template_name}
                  onChange={(e) => setInputValue(e)}
                />
              </label>
            </div>
          </div>
          <div className="fc-5">
            <div className="input-wrapper">
              <p className="input-title">Sender ID</p>
              <label className="input">
                <input
                  type="text"
                  placeholder="Sender ID"
                  id="sender_id"
                  onChange={(e) => setInputValue(e)}
                  value={smsTemplateData?.sender_id}
                />
              </label>
            </div>
          </div>
          <div className="fc-5">
            <div className="input-wrapper">
              <p className="input-title">DLT ID</p>
              <label className="input">
                <input
                  type="text"
                  placeholder="DLT Template ID"
                  id="dlt_id"
                  onChange={(e) => setInputValue(e)}
                  value={smsTemplateData?.dlt_id}
                />
              </label>
            </div>
          </div>
          <div className="fc-5">
            <div className="input-wrapper">
              <p className="input-title">DLT Template ID</p>
              <label className="input">
                <input
                  type="text"
                  id="dlt_templateid"
                  placeholder="DLT Template ID"
                  onChange={(e) => setInputValue(e)}
                  value={smsTemplateData?.dlt_templateid}
                />
              </label>
            </div>
          </div>
          <div className="fc-5">
            <div className="input-wrapper">
              <p className="input-title">SMS Type</p>
              <label className="select">
                <select
                  id="sms_type"
                  onChange={(e) => setInputValue(e)}
                  value={smsTemplateData?.sms_type}
                >
                  <option value="" selected disabled>
                    Select type
                  </option>
                  <option value="transactional">Transactional</option>
                </select>
              </label>
            </div>
          </div>
          <div className="fc-12">
            <div className="input-wrapper">
              <p className="input-title ">SMS Content</p>
              <div className="card p-2 my-2 bg-light">
                <p className="mini-text">
                  For Dynamic values use keyword <b>param</b> followed by
                  position inside {`"@{}"`} in place of any link use keyword{" "}
                  <b>link</b>. <br />
                  <p className="mt-2">
                    e.g. Dear <b>{"@{param1}"}</b>, You have opted to pay{" "}
                    <b>{"@{param2}"}</b> for <b>{"@{param3}"}</b>. Tap{" "}
                    <b>{"@{link}"}</b> to pay. - ABCDLT
                  </p>
                </p>
              </div>
              <textarea
                id="message_body"
                className="textarea"
                rows={8}
                placeholder="Message Body"
                onChange={(e) => setInputValue(e)}
                value={smsTemplateData?.message_body}
              ></textarea>
            </div>
          </div>
          <div className="fc mt-3">
            <div className="input-wrapper fc-5">
              <p className="input-title">Mobile Number</p>
              <label className="input">
                <input
                  type="text"
                  placeholder="Mobile No"
                  id="mobile_no"
                  onChange={(e) => setInputValue(e)}
                />
              </label>
            </div>
          </div>
          <div className="fc-12 text-right">
            <button className="btn-primary btn--sm" onClick={() => verifySMS()}>
              Verify and Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateSMSTemplate;
